import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../components/ui/Loading";
import { fetchRelatedPosts } from "../../features/relatedPosts/relatedPostsSlice";
import RelatedPostListItem from "./RelatedPostListItem";

export default function RelatedPostList({ currentPostId, tags }) {
  const dispatch = useDispatch();
  const { relatedPosts, isLoading, isError, error } = useSelector(
    (state) => state.relatedPosts
  );

  useEffect(() => {
    dispatch(fetchRelatedPosts({ tags, id: currentPostId }));
  }, [dispatch, tags, currentPostId]);

  // decide what to render
  let content = null;

  if (isLoading) content = <Loading />;
  if (!isLoading && isError) {
    content = <h1>{error}</h1>;
  }
  if (!isLoading && !isError && relatedPosts?.length === 0) {
    content = <h1>No related posts found!</h1>;
  }
  if (!isLoading && !isError && relatedPosts?.length > 0) {
    content = relatedPosts.map((post) => (
      <RelatedPostListItem key={post.id} post={post} />
    ));
  }

  return <div className="space-y-4 related-post-container">{content}</div>;
}
